module.exports = __webpack_public_path__ + "img/museum.b8c69237.svg";